import { createContext, useContext, useEffect, useState, useMemo } from "react";

const WishlistContext = createContext(null);
const KEY = "bathlane_wishlist";

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const has = (id) => items.some((i) => i.id === id);
  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
  const toggle = (item) =>
    setItems((prev) =>
      prev.some((p) => p.id === item.id)
        ? prev.filter((p) => p.id !== item.id)
        : [...prev, item]
    );
  const clear = () => setItems([]);
  const count = useMemo(() => items.length, [items]);

  return (
    <WishlistContext.Provider value={{ items, has, remove, toggle, clear, count }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
